export var IdIconTextPosition;
(function (IdIconTextPosition) {
    IdIconTextPosition["Center"] = "Center";
    IdIconTextPosition["Under"] = "Under";
})(IdIconTextPosition || (IdIconTextPosition = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdIconTextPosition.ts
// module id = 870
// module chunks = 3